import HistoryChanged from "./HistoryChanged.vue";

export default {
  name: "HistoryGeneralConfiguration",
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },

    displayFields: {
      type: Array | Object,
      default: [],
    },

    historyData: {
      type: Array,
      default: [],
    },

    handleFormatData: Function,
  },
  watch: {
    formData(value) {
      this.mappingDisplayData(value);
    },
  },
  components: { HistoryChanged },
  data() {
    return {
      // handle show modal
      isVisibleModal: false,
      historyDisplay: [],
    };
  },
  computed: {},
  created() { },
  mounted() {
    this.mappingDisplayData(this.formData);
  },
  methods: {
    handleOk() {
      return true;
    },

    onChangeStaff(value) {
      this.form.staff = value;
    },

    mappingDisplayData(rawData) {
      let recordValue = null;

      if (rawData.new_record) {
        recordValue = rawData.new_record;
      } else {
        recordValue = rawData;
      }

      // convert formData to specific format data needed
      const formattedData = this.handleFormatData(recordValue);
      // mapping display data
      const historyDisplay = [];
      for (const key in formattedData) {
        // Set display name for form. Depends-on display name list have sent from parent form
        let displayName = key;
        if (key in this.displayFields) {
          displayName = this.displayFields[key]
        }

        historyDisplay.push({
          name: displayName,
          value: formattedData[key],
        });
      }

      this.historyDisplay = historyDisplay;
    },
  },
  destroyed() { },
};
